export const NotFoundPageENUSTranslations = {
  notFoundPageTitle: 'Page not found',
  notFoundPageDescription:
    "Sorry, we couldn't find that page. Please check if the link is correct or try again later.",
};
